import { Button } from "react-bootstrap";
import ImageBlock from "./report/blocks/ImageBlock";
import KorttiIdGetter from "./KorttiIdGetter";
import Can from "../permissions/Can";
import { PERMISSIONS } from "../permissions/permissions";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { moveImagesToAnotherKiinteisto } from "../api/api";

export default function KiinteistoGallery({ propertyId }) {
  const [showKorttiModal, setShowKorttiModal] = useState(false);
  const [kiinteistoToMoveId, setKiinteistoToMoveId] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const galleryCategory = searchParams.get('category') || '';
  const gallerySubCategory = searchParams.get('subCategory') || null;

  const handleGalleryChange = (newData) => {
    const params = { tab: 'kuvat' };
    if (newData.category) params.category = newData.category;
    if (newData.subCategory) params.subCategory = newData.subCategory;
    setSearchParams(params);
  };

  return (
    <div className="pt-1 pb-3 px-3 px-md-5" style={{ paddingLeft: 'clamp(1rem, 8vw, 6rem)', paddingRight: 'clamp(1rem, 8vw, 6rem)' }}>
      <div className="d-flex justify-content-center mb-1 mt-0">
          <Button
            variant="link"
            className="d-flex align-items-center justify-content-center"
            onClick={() => {
              setKiinteistoToMoveId(propertyId);
              setShowKorttiModal(true);
            }}
          >
            <i className="bi bi-box-arrow-in-right fs-5"></i>{" "}
            <span className="ms-1">Siirrä kuvat</span>
          </Button>
      </div>

      <ImageBlock
        uiLimit={8}
        mode="gallery"
        data={{ category: galleryCategory, subCategory: gallerySubCategory }}
        onChange={handleGalleryChange}
      />

      {/* The modal to pick target kiinteisto */}
      {showKorttiModal && (
        <KorttiIdGetter
          show={showKorttiModal}
          onClose={() => setShowKorttiModal(false)}
          onSelect={async (targetId) => {
            await moveImagesToAnotherKiinteisto(kiinteistoToMoveId, targetId);
            setShowKorttiModal(false); // hide after API call
          }}
        />
      )}
    </div>
  );
}
